export const ENDPOINTS = {
  getPack: '/gateway/admin/packs/:id',
  getPacks: '/gateway/admin/packs',
  getPublishedPacks: '/gateway/admin/packs/published',
  publishPack: '/gateway/admin/packs/:packId/publish',
  unpublishPack: '/gateway/admin/packs/:packId/unpublish',
  hidePack: '/gateway/admin/packs/:packId/hide',
  createPack: '/gateway/admin/packs',
  updatePack: '/gateway/admin/packs/:id',
  deletePack: '/gateway/admin/packs/:id',
} as const;

export const CORE_QUERY_KEYS = {
  packs: 'packs',
  pack: 'pack',
  editoPacks: 'admin-edito-packs',
  voucherPacks: 'admin-voucher-packs',
} as const;
